webpackJsonp([4],{

/***/ 1060:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _socialLogin = __webpack_require__(1265);

var _socialLogin2 = _interopRequireDefault(_socialLogin);

var _loginForm = __webpack_require__(1267);

var _loginForm2 = _interopRequireDefault(_loginForm);

var _languageSelector = __webpack_require__(934);

var _languageSelector2 = _interopRequireDefault(_languageSelector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'login',

    props: ['logo'],

    data: function data() {
        return {
            user: {
                email: '',
                password: '',
                remember: false
            },
            error: false,
            isCompanion: false
        };
    },
    methods: {
        loginAction: function loginAction() {
            var _this = this;

            var success = function success(response) {
                if (response !== undefined && response.data !== undefined) {
                    eventHub.$emit('user.login', response.data.data, _this.user.remember);

                    localStorage.setItem('token', response.data.data.token);

                    var redirect = Cookies.get('login-redirect');
                    if (redirect !== undefined) {
                        Cookies.expire('login-redirect');
                        window.location = '/app' + redirect;
                        return;
                    }

                    window.location = '/app/dashboard';
                }
            };

            var failure = function failure(response) {
                var msg = response.data.message;
                var errors = response.data.errors;

                for (var key in errors) {
                    if (errors.hasOwnProperty(key)) {
                        msg += '\n' + errors[key];
                    }
                }

                swal({
                    title: _this.$i18n.general.oops,
                    text: msg,
                    icon: 'error',
                    buttons: [_this.$i18n.auth.login_in_failure.try_again, _this.$i18n.auth.login_in_failure.reset_password]
                }).then(function (confirmed) {
                    if (confirmed) {
                        _this.$router.push('recover-password');
                    }
                });
            };

            this.$http.post('session', this.user).then(success, failure);
        },

        loginWithFacebook: function loginWithFacebook() {
            console.log('login with Facebook');
        },

        loginWithTwitter: function loginWithTwitter() {
            console.log('login with Twitter');
        },

        loginWithMultibrain: function loginWithMultibrain() {
            console.log('login with Multibrain');
        }
    },

    components: { SocialLogin: _socialLogin2.default, LoginForm: _loginForm2.default, LanguageSelector: _languageSelector2.default },

    mounted: function mounted() {
        this.isCompanion = /Multibrain\/Companion/.test(window.navigator.userAgent);

        var self = this;
        this.$nextTick(function () {
            if (window.error !== undefined) {
                swal({
                    title: self.$i18n.general.oops,
                    text: window.error.message,
                    icon: 'error',
                    button: self.$i18n.general.ok
                });
                delete window.error;
            }
        });

        this.$nextTick(function () {
            this.$http.get('session', this.user).then(function (response) {
                if (response !== undefined && response.data !== undefined) {
                    if (response.data.data.token !== undefined) {
                        eventHub.$emit('user.login', response.data.data, this.user.remember);

                        localStorage.setItem('token', response.data.data.token);

                        var redirect = Cookies.get('login-redirect');
                        if (redirect !== undefined) {
                            Cookies.expire('login-redirect');
                            window.location = '/app' + redirect;
                            return;
                        }

                        window.location = '/app/dashboard';
                    }
                }
            }).catch(function (error) {
                // user is unauthenticated
                if (Cookies.get('login-redirect')) {
                    // user attempted to access a specific page before logging in

                    // admins can get stuck in a loop of redirects
                    // we'll keep track of the number of times they've been here
                    // and nope out if they appear to be stuck
                    var redirectCount = parseInt(Cookies.get('login-redirect-count')) || 0;
                    Cookies.set('login-redirect-count', redirectCount + 1, { expires: 60 });

                    if (redirectCount >= 2) {
                        Cookies.expire('login-redirect');
                        Cookies.expire('login-redirect-count');
                        return;
                    }

                    // special handling only for R+F for now
                    switch (window.location.hostname) {
                        case 'rodan.test':
                        case 'stg-social.rodanandfields.com':
                        case 'social.rodanandfields.com':
                            window.location.replace('/');
                            return;
                    }
                }
            });
        });
    }

}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ 1061:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//

exports.default = {
    props: ['faIcon', 'text', 'loginAction'],
    data: function data() {
        return {};
    }
};

/***/ }),

/***/ 1062:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    props: ['loginAction', 'user'],

    data: function data() {
        return {};
    },

    computed: {
        emailStyle: function emailStyle() {
            if (this.$route.name == 'login-email') {
                return 'block';
            }

            return 'none';
        },
        fbStyle: function fbStyle() {
            if (this.$route.name == 'login') {
                return 'block';
            }

            return 'none';
        }
    },

    methods: {
        showFacebookForm: function showFacebookForm() {
            $('.login-form').hide();
            $('.fb-login').slideDown(500);
        },
        showLoginForm: function showLoginForm() {
            $('.fb-login').hide();
            $('.login-form').slideDown(500);
            $('#email')[0].focus();
        }
    }
};

/***/ }),

/***/ 1265:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_social_login_vue__ = __webpack_require__(1061);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_social_login_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_social_login_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_social_login_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_social_login_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b36da674_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_social_login_vue__ = __webpack_require__(1266);
var disposed = false
var normalizeComponent = __webpack_require__(68)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_social_login_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b36da674_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_social_login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "resources/assets/js/components/login/social-login.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-b36da674", Component.options)
  } else {
    hotAPI.reload("data-v-b36da674", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1266:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "btn btn-default",
      attrs: { href: "#" },
      on: { click: _vm.loginAction }
    },
    [_c("i", { class: _vm.faIcon }), _vm._v("   " + _vm._s(_vm.text))]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b36da674", esExports)
  }
}

/***/ }),

/***/ 1267:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_form_vue__ = __webpack_require__(1062);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_form_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_form_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_form_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_form_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05e263b6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_login_form_vue__ = __webpack_require__(1268);
var disposed = false
var normalizeComponent = __webpack_require__(68)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_form_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05e263b6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_login_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "resources/assets/js/components/login/login-form.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-05e263b6", Component.options)
  } else {
    hotAPI.reload("data-v-05e263b6", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1268:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      on: {
        submit: function($event) {
          $event.preventDefault()
          _vm.loginAction($event)
        }
      }
    },
    [
      _c("div", { staticClass: "fb-login", style: { display: _vm.fbStyle } }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-12 text-center" }, [
            _c("div", { staticClass: "form-group" }, [
              _c(
                "a",
                {
                  staticClass: "btn btn-facebook",
                  attrs: { href: "/app/auth/facebook", role: "button" }
                },
                [
                  _c("span", { staticClass: "fab fa-facebook-f" }),
                  _vm._v(
                    " " +
                      _vm._s(_vm.$i18n.auth.login_with_facebook) +
                      "\n                    "
                  )
                ]
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row or-login" }, [
          _c("div", { staticClass: "col-md-12 text-center" }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.$i18n.general.or) +
                "\n            "
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-12 text-center" }, [
            _c("label", [
              _c(
                "a",
                {
                  staticClass: "text-light show-login-form",
                  on: { click: _vm.showLoginForm }
                },
                [_vm._v(_vm._s(_vm.$i18n.auth.login_with_email_password))]
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "login-form", style: { display: _vm.emailStyle } },
        [
          _c("div", { staticClass: "form-group" }, [
            _c("label", { attrs: { for: "email" } }, [
              _vm._v(_vm._s(_vm.$i18n.auth.email_address))
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.user.email,
                  expression: "user.email"
                }
              ],
              staticClass: "form-control",
              attrs: { name: "email", type: "email", id: "email" },
              domProps: { value: _vm.user.email },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.user.email = $event.target.value
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("label", { attrs: { for: "password" } }, [
              _vm._v(_vm._s(_vm.$i18n.auth.password))
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.user.password,
                  expression: "user.password"
                }
              ],
              staticClass: "form-control",
              attrs: {
                name: "password",
                type: "password",
                value: "",
                id: "password"
              },
              domProps: { value: _vm.user.password },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.user.password = $event.target.value
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-12 text-center" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("input", {
                  staticClass: "btn btn-login",
                  attrs: { type: "submit" },
                  domProps: { value: _vm.$i18n.auth.log_in }
                })
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-6" }, [
              _c("div", { staticClass: "checkbox" }, [
                _c("label", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.user.remember,
                        expression: "user.remember"
                      }
                    ],
                    attrs: { name: "remember", type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(_vm.user.remember)
                        ? _vm._i(_vm.user.remember, null) > -1
                        : _vm.user.remember
                    },
                    on: {
                      __c: function($event) {
                        var $$a = _vm.user.remember,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$c) {
                            $$i < 0 && (_vm.user.remember = $$a.concat($$v))
                          } else {
                            $$i > -1 &&
                              (_vm.user.remember = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.user.remember = $$c
                        }
                      }
                    }
                  }),
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$i18n.auth.remember_me) +
                      "\n                    "
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6 text-right" }, [
              _c("div", { staticClass: "forgot-text" }, [
                _c(
                  "label",
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "text-light",
                        attrs: { to: { name: "recover-password" } }
                      },
                      [_vm._v(_vm._s(_vm.$i18n.auth.forgot_password))]
                    )
                  ],
                  1
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row spacer-30" }, [
            _c("div", { staticClass: "col-md-12 text-center" }, [
              _c("label", [
                _c(
                  "a",
                  {
                    staticClass: "show-fb-form",
                    on: { click: _vm.showFacebookForm }
                  },
                  [
                    _c("i", {
                      staticClass: "fab fa-facebook-square",
                      attrs: { "aria-hidden": "true" }
                    }),
                    _vm._v(" " + _vm._s(_vm.$i18n.auth.login_with_facebook))
                  ]
                )
              ])
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-05e263b6", esExports)
  }
}

/***/ }),

/***/ 1269:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.isCompanion
        ? _c("div", { staticClass: "alert alert-danger" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$i18n.auth.session_expired_companion) +
                "\n    "
            )
          ])
        : _c("div", { staticClass: "login-page" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-md-5 col-sm-12 col-xs-12 well" },
                [
                  _c("login-form", {
                    attrs: { "login-action": _vm.loginAction, user: _vm.user }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            false
              ? _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-md-6 col-md-offset-3 text-center" },
                    [
                      _c("h4", [
                        _vm._v(_vm._s(_vm.$i18n.auth.already_connected))
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c("social-login", {
                            attrs: {
                              "fa-icon": "fab fa-facebook-f",
                              text: "Login with Facebook",
                              "login-action": _vm.loginWithFacebook
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c("social-login", {
                            attrs: {
                              "fa-icon": "fa fa-lock",
                              text: "Login with Multibrain",
                              "login-action": _vm.loginWithMultibrain
                            }
                          })
                        ],
                        1
                      )
                    ]
                  )
                ])
              : _vm._e()
          ]),
      _vm._v(" "),
      _c("language-selector")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-md-6 col-md-offset-3 text-center logo-login" },
        [_c("div", { attrs: { id: "logo-image" } })]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-69787b62", esExports)
  }
}

/***/ }),

/***/ 445:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_vue__ = __webpack_require__(1060);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69787b62_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_login_vue__ = __webpack_require__(1269);
var disposed = false
var normalizeComponent = __webpack_require__(68)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69787b62_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "resources/assets/js/components/login.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-69787b62", Component.options)
  } else {
    hotAPI.reload("data-v-69787b62", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 878:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    name: 'language-selector',
    data: function data() {
        return {
            languages: [{ name: 'English', id: 'en', active: false }, { name: 'Español', id: 'es', active: false }]
        };
    },
    methods: {
        setSystemLanguage: function setSystemLanguage(languageId) {
            var self = this;
            this.languages.map(function (language) {
                if (language.id === languageId) {
                    language.active = true;
                    window.sessionStorage.setItem("language", language.id);
                    self.$root.$setLanguage(language.id);
                } else {
                    //reset active status
                    language.active = false;
                }
            });
        }
    },
    mounted: function mounted() {
        if (this.$store.state.user !== undefined && this.$store.state.user != null && this.$store.state.user.available_languages !== undefined) {
            var languageOptions = this.$store.state.user.available_languages;

            this.languages = [];
            for (var key in this.languageOptions) {
                this.languages.push({ 'id': key, 'name': languageOptions[key], 'active': false });
            }
        }

        var languageId = this.$route.query.lang === undefined ? 'en' : this.$route.query.lang;
        this.setSystemLanguage(languageId);
    }
};

/***/ }),

/***/ 934:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_language_selector_vue__ = __webpack_require__(878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_language_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_language_selector_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_language_selector_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_language_selector_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a1f68a6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_language_selector_vue__ = __webpack_require__(935);
var disposed = false
var normalizeComponent = __webpack_require__(68)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_language_selector_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a1f68a6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_language_selector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "resources/assets/js/components/language-selector.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3a1f68a6", Component.options)
  } else {
    hotAPI.reload("data-v-3a1f68a6", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 935:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "language-chooser" },
    _vm._l(_vm.languages, function(language, index) {
      return _c("li", [
        _c(
          "a",
          {
            class: { active: language.active },
            attrs: { href: "#" },
            on: {
              click: function($event) {
                $event.preventDefault()
                _vm.setSystemLanguage(language.id)
              }
            }
          },
          [_vm._v("\n            " + _vm._s(language.name) + "\n        ")]
        ),
        _vm._v(" "),
        index !== _vm.languages.length - 1
          ? _c("span", [_vm._v("|")])
          : _vm._e()
      ])
    })
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3a1f68a6", esExports)
  }
}

/***/ })

});


// WEBPACK FOOTER //
// 4.011b160eada929a1ff7b.js